import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'minuteSeconds',
    standalone: true
})
export class MinuteSecondsPipe implements PipeTransform {

  transform(value: number): string {
    if(value < 0) value = 0
    const minutes: number = Math.floor(value / 60);
    const seconds: number = value - minutes * 60;

    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

}
